import classNames from 'classnames';
import { IconClose } from '@medifind/icons';
import { Button } from './inputs/Button';
import styles from './ExpandButton.module.scss';

const ExpandButton = ({ isExpanded, onClick, label, className, classes = {}, size = 'xlarge', color, style = {}, title }) => {
  return (
    <div className={classNames(styles['expand-button'], className, { [styles['expanded']]: isExpanded })}>
      <Button
        icon={<IconClose size={size} strokeWidth="thin" circle={false} color={style.accordionIconColor} />}
        classes={classes.button}
        focus="outline"
        buttonProps={{ 'aria-expanded': isExpanded }}
        label={label}
        onClick={onClick}
        noPadding
        screenReaderText={isExpanded ? `Collapse ${title} Section` : `Expand ${title} Section`}
      />
    </div>
  );
};

export { ExpandButton as default, ExpandButton };
